module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    ref: "bg",
    staticClass: "bg",
    on: {
      "mouseover": function($event) {
        return _vm.bgOver(_vm.$refs.bg)
      },
      "mousemove": function($event) {
        return _vm.bgMove(_vm.$refs.bg, $event)
      },
      "mouseout": function($event) {
        return _vm.bgOut(_vm.$refs.bg)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.data.data), function(item, i) {
    return (i === _vm.mark) ? _c('div', {
      key: i,
      staticStyle: {
        "position": "absolute"
      },
      on: {
        "click": function($event) {
          return _vm.linkTo(item)
        },
        "mouseover": _vm.stopTimer,
        "mouseout": _vm.startTimer
      }
    }, [(item.imgUrl) ? _c('img', {
      staticClass: "img1",
      attrs: {
        "src": item.imgUrl
      }
    }) : _vm._e()]) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('ul', {
    staticClass: "dots"
  }, _vm._l((_vm.data.data), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "dot-active",
      class: {
        'dot': i != _vm.mark
      },
      on: {
        "click": function($event) {
          return _vm.change(i)
        }
      }
    })
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-fa9198f0","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/banner.vue
// module id = 798
// module chunks = 0 1 3